export default "__VITE_ASSET__CNDoWwNc__"